import {css} from "styled-components"

export const mainStyles = css`
  ${({theme}) => `
    font-family: ${theme.font.bold};
    color: ${theme.colors.utility.ink};
  `}
`

export const largeStyles = css`
  font-size: 52px;
  line-height: 58px;
  letter-spacing: -0.5px;
`

export const regularStyles = css`
  font-size: 24px;
  line-height: 28px;
  letter-spacing: 0;
`

export const smallStyles = css`
  font-size: 12px;
  line-height: 22px;
  letter-spacing: 0.2px;
`
